module.exports = __webpack_public_path__ + "img/skgf.73ba84ba.jpg";